import React, { useState } from "react";
import styled from "styled-components";
import media from "cssMix/index";
import cx from "classnames";
import { Trans } from "react-i18next";
import { Map } from "immutable";
import useMediaQuery from "useHooks/useMediaQuery";
// comp
import SearchBar from "Components/common/SearchBar";
// icon
import { IoIosCloseCircle } from "react-icons/io";

export default ({
  searchValue,
  t,
  clearSearchValue,
  isSticky,
  gameType,
  handleMenuClick,
  menuList,
}) => {
  const [isFocus, setIsFocus] = useState(false);
  const focusHandler = (bool) => {
    setIsFocus(bool);
  };
  const { mediaType } = useMediaQuery();
  return (
    <>
      <SearchBarArea
        isSticky={isSticky}
        isFocus={isFocus}
        mediaType={mediaType}
      >
        <GameType isFocus={isFocus} className={cx({ focus: isFocus })}>
          {menuList.map((v, index) => {
            const listName = v.get("name", Map());
            const name = t(listName);
            const gaClass = v.get("gaClass", Map());
            return (
              <div
                key={name}
                className={cx([
                  gaClass,
                  { focus: !searchValue && gameType.get("index") === index },
                ])}
                onClick={handleMenuClick.bind(null, Map({ index, value: v }))}
              >
                <p>{name}</p>
              </div>
            );
          })}
        </GameType>
        <div className={cx(["bar", { focus: isFocus }])}>
          <div
            className="bx bx-search search-icon gav2_btn_search"
            onClick={() => focusHandler(true)}
          />
          <SearchBar
            focusHandler={focusHandler}
            onClick={() => focusHandler(true)}
            isFocus={isFocus}
          />
          {searchValue && (
            <IoIosCloseCircle
              className="close-icon"
              onClick={() => {
                clearSearchValue();
                focusHandler(false);
              }}
            />
          )}
        </div>
      </SearchBarArea>
      {searchValue && (
        <SearchResult>
          <Trans i18nKey="searchText">
            <span className="searchValue">{{ searchValue }}</span>
          </Trans>
        </SearchResult>
      )}
    </>
  );
};

const SearchBarArea = styled.div`
  position: ${(props) => (props.isSticky ? "fixed" : "relative")};
  width: ${(props) =>
    props.isSticky
      ? props.mediaType === "pc"
        ? "calc(100% - 260px)"
        : "100%"
      : "100%"};
  top: 0;
  right: ${(props) => (props.isSticky ? "0px" : "")};
  margin: ${(props) => (props.isSticky ? "" : "0 0 30px")};
  background: ${(props) =>
    props.isSticky
      ? props.mediaType === "pc"
        ? `url("images/bg.png") no-repeat, #12110f`
        : `linear-gradient(to right, #161826, #1e1738 100%)`
      : ""};
  background-size: ${(props) => (props.isSticky ? "cover" : "")};
  box-shadow: ${(props) =>
    props.isSticky ? "0 5px 8px 0 rgba(0, 0, 0, 0.3)" : ""};
  z-index: 8;
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #ffffff;
  font-size: 26px;
  box-sizing: border-box;
  padding: ${(props) => (props.isSticky ? "0 5%" : "0")};
  .bar {
    position: relative;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    width: 330px;
    height: 50px;
    border: solid 1px ${({ theme }) => theme.colors["4"]};
    border-radius: 8px;
    padding: 14px 10px;
    background: #141620;
    border: ${(props) =>
      props.isFocus
        ? "solid 1px #f9be00"
        : "solid 1px rgba(130, 136, 151, 0.6)"};
    > input {
      width: 100%;
      height: 100%;
      background: transparent;
      color: ${(props) =>
        props.isFocus ? "rgba(255, 255, 255, 1)" : "rgba(255, 255, 255, 0.7)"};
      font-size: 16px;
      font-weight: 500;
      padding-left: 10px;
    }
    & .search-icon {
      color: ${(props) =>
        props.isFocus ? "rgba(255, 255, 255, 1)" : "rgba(255, 255, 255, 0.7)"};
      font-size: 18px;
    }
    & .close-icon {
      position: relative;
      color: #f9be00;
      cursor: pointer;
      width: 20px;
      height: 20px;
    }
  }
  ${media.tablet`
  padding: ${(props) => (props.isSticky ? "0 16px" : "0")};
  margin:0;
  & .bar{
    width:40px;
    height:40px;
    padding:0 10px;
    transition:width .3s  ease;
    &.focus{
      width:100%;
    }
  }
    `}
`;
const GameType = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  font-size: 18px;
  font-weight: 500;
  transition-property: width, border, padding;
  transition-duration: 0.1s;
  transition-timing-function: ease;
  & div {
    height: 100%;
    display: flex;
    align-items: center;
    margin-right: 5%;
    cursor: pointer;
    &.focus {
      position: relative;
      color: #f9be00;
      &::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 3px;
        border-radius: 1.5px;
        background-color: #f9be00;
      }
    }
  }
  ${media.tablet`
  display:flex;
  flex:1;
  box-sizing:border-box;
  justify-content:flex-start;
  height:40px;
  border: solid 1px rgba(130, 136, 151, 0.6);
  background-color:#141620;
  border-radius: 8px;
  margin-right:8px;
  padding:0 15px;
  font-size: 14px;
  overflow-x: overlay;
  &.focus{
    width:0;
    padding:0;
    border: none;

  }
  & div{
    flex-shrink:0;
    margin-right:20px;
  }
  `}
`;
const SearchResult = styled.div`
  color: ${({ theme }) => theme.colors["4"]};
  font-size: 16px;
  margin: 0 0 40px;
  .searchValue {
    color: ${({ theme }) => theme.colors["1"]};
  }
  ${media.tablet`
    margin:24px 0 0;
    `}
  ${media.mobile`
    font-size:14px;
    `}
`;
